import React from "react";
import { m1, m2, m25, m26, m27, m28, m3, MobileAppBanner, Vulnerability } from "../../Assets.tsx";
import { ServiceShell, Section, Hero, Intro, Split, FeatureGrid, CheckList, Cta } from "../Common-component/ServiceKit";

const monitoring = [
  {
    img: m26,
    alt: "Vitals",
    title: "Vitals for Android",
    text: "You can enhance the stability and functionality of Google Play apps on Android devices with the aid of Android vitals. We advise prioritizing and monitoring your app's vitals for the best end-user experience.",
  },
  {
    img: m27,
    alt: "JankStats",
    title: "JankStats database",
    text: "Utilize the JankStats library to monitor and examine the application's slow rendering frames and provide reports on the jank statistics affecting your users.",
  },
  {
    img: m28,
    alt: "Continuous integration",
    title: "Integrating continuously",
    text: "Before pushing the update to your users, use benchmarks as part of your CI pipeline to track performance evolution and identify performance regressions (or improvements).",
  },
];

const appMonitoring = [
  {
    img: m1,
    alt: "Malfunction detection",
    title: "Malfunction Detection",
    text: "You may avoid guessing or searching through an Android error log by looking at crash reports for Android apps that provide information like the filename and line number. Android exceptions can be intuitively filtered and grouped to reduce noise. Count errors at a large scale without affecting manufacturing throughput.",
  },
  {
    img: m2,
    alt: "Performance",
    title: "Performance Of Android Applications",
    text: "You can monitor your mobile apps’ usability, speed, and stability in real-time using our developers’ mobile application monitoring system.",
  },
  {
    img: m3,
    alt: "User experience",
    title: "Boost Android Mobile User Experience",
    text: "You may get integrated monitoring for your mobile apps and your backend services from services provided by our developers. You can quickly identify the source of an issue, allowing you to proactively steer clear of unfavourable app evaluations with the dynamically built applications.",
  },
];

const MobilePage = () => (
  <ServiceShell>
    {/* HERO */}
    <Hero
      chip="Mobile Apps"
      title="Android Mobile App Development"
      sub="Designing apps for the android ecosystem"
      paragraphs={[
        "Finding the source of slowdowns and problems that are using the most resources, such as CPU or RAM, and compromising the performance of Android applications on the user’s mobile device is what Mobile app development is. Learn how your application performs on real-user devices in production environments at the code level. Mobile app development Java can be the best choice if you want to make an Android app. A recent survey found that 69.7% of developers use JavaScript, making it the most common language. The second most used language is HTML/CSS, with 62.4%.",
      ]}
      tags={["Android", "Kotlin", "Java", "Jetpack Compose"]}
      img={MobileAppBanner}
      alt="Android app development"
    />

    {/* MONITOR & UPGRADE */}
    <Section tint>
      <Split
        img={m25}
        alt="Android performance"
        chip="Performance"
        title="Monitor And Upgrade Your Android Performance With Our Expert Assistance"
        paragraphs={[
          "Monitoring and evaluating your application’s performance offers useful information about the general user experience. Continuous performance monitoring enables you to spot problems and optimize for them before they can affect additional people.",
        ]}
      />
      <FeatureGrid items={monitoring} cols={3} />
    </Section>

    {/* APPLICATION MONITORING */}
    <Section style={{ paddingBottom: 30 }}>
      <Intro chip="Monitoring" title="Android Application Monitoring" />
    </Section>
    {appMonitoring.map((p, i) => (
      <Section key={p.title}>
        <Split img={p.img} alt={p.alt} reverse={i % 2 === 1} title={p.title} paragraphs={[p.text]} />
      </Section>
    ))}

    {/* VULNERABILITY */}
    <Section tint>
      <Split
        img={Vulnerability}
        alt="Vulnerability of mobile app development"
        reverse
        chip="Robust Builds"
        title="Vulnerability Of Mobile App Development"
        sub="Turn design templates into functioning apps."
        paragraphs={[
          "Our Android Mobile app developers at ATUM Information Technology create tests for code to ensure robustness and performance. Get the best robust final product made by our skilled android developers.",
        ]}
      >
        <CheckList
          items={[
            "It develops design tools: By using Jetpack Compose, create dynamic layouts. Next, check out your layouts on any size screen and examine Compose animations with the built-in inspection tools.",
            "Create a smart code editor: With an intelligent code editor that offers code completion for Kotlin, Java, and C/C++ programming languages, you can write better code, complete tasks more quickly, and be more productive.",
            "Flexible building system: The build system in ATUM Information Technology enables you to configure your build so that it may produce several build versions for various Android devices from a single project. Use the Build Analyzer to assess the build performance and identify any potential build issues in your project.",
            "Emulating any device easily: You can test your application on various Android devices using the Android Emulator. Use responsive layouts that adjust to accommodate phones, tablets, foldable, and Chrome OS devices to maximize the functionality of your apps.",
            "APK Bundle for Android: Publish and examine the contents of your app's APK file or Android App Bundle to look for ways to reduce the size of your Android app before publishing.",
          ]}
        />
      </Split>
    </Section>

    {/* WHY US */}
    <Cta
      chip="Why Us"
      title="Why Choose Our Android Developer?"
      paragraphs={[
        "The top Android mobile app developers at ATUM Information Technology are at your service, and they would build the best app, an informative one that would serve your purpose. At ATUM Information Technology, we provide the best service. So hire our android mobile app developers soon. Fixing known bugs in existing Android applications and adding new features to the apps is what our Android developers do.",
      ]}
    />
  </ServiceShell>
);

export default MobilePage;